import AdminListPage from "./components/AdminListPage";
export default function AkaunList() { return <AdminListPage title="Senarai Akaun" endpoint="/admin/akaun" />; }
